import React from 'react';
import {injectIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';
import FormGroupField from '../FormGroupField';

export const AwsParameters = ({provider}) => {
    const labels = messages.admin.organization.sendProviders[provider].parameters;
    return (
        <>
            <div className="col-12">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-email-configurationSet"
                    name="parameters.email.configurationSet"
                    label={labels.email.configurationSet} />
            </div>
            <div className="col-12">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-sms-configurationSetName"
                    name="parameters.sms.configurationSetName"
                    label={labels.sms.configurationSetName} />
            </div>
            <div className="col-12">
                <FormGroupField type="text"
                    id="uef-organization-sendProvider-parameters-sms-optOutListName"
                    name="parameters.sms.optOutListName"
                    label={labels.sms.optOutListName} />
            </div>
        </>
    );
};

export default injectIntl(AwsParameters);
